import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";
import { CategoryItem } from "core/http/service/category/resTypes";
import {
  getListManagersRecruitmentUrl,
  getRecruitmentDepartmentEmployee,
  getRecruitmentDepartmentPosition,
  getRelatedPersons,
} from "core/http/service/category/urls";
import { getManagerByLevelUrl } from "core/http/service/evaluation/url";

export type Query = Record<string, any>;

export const PERSONAL_INFORMATION_CATEGORY = {
  ACCOUNTING: "ACCOUNTING", // Khu vực hạch toán
  ACKNOWLEDGE_TURNOVER: "ACKNOWLEDGE_TURNOVER", // Tỉ lệ ghi nhận doanh thu
  ACTION_TYPE: "ACTION_TYPE", // Loại thao tác
  ADMIN_COUNCIL_LEVEL_SIGN: "ADMIN_COUNCIL_LEVEL_SIGN", // Cấp ký HĐQT
  ALLOWANCE: "ALLOWANCE", // Các loại phụ cấp
  APPROVE_STATUS: "APPROVE_STATUS", // Trạng thái duyệt
  APPROVE_STATUS_2: "APPROVE_STATUS_2", // Trạng thái duyệt (4 trạng thái)
  AUTHORITY_TYPE: "AUTHORITY_TYPE", // Loại Ủy quyền
  AUTHORIZATION_SIGN: "AUTHORIZATION_SIGN", // Thẩm quyền ký
  BANK: "BANK", // Ngân hàng
  CATEGORY_TEMPLATE: "CATEGORY_TEMPLATE", // Mẫu báo cáo
  CEO_LEVEL_SIGN: "CEO_LEVEL_SIGN", // Cấp ký TGĐ
  CERTIFICATE_INSTEAD: "CERTIFICATE_INSTEAD", // Chứng chỉ hành nghề thay thế
  CERTIFICATE_TYPE: "CERTIFICATE_TYPE", // Chứng chỉ hành nghề
  CERTIFICATE_TYPE_02: "CERTIFICATE_TYPE_02", // Chứng chỉ theo quy định của pháp luật hay công ty
  CHELLENGE_RESULT: "CHELLENGE_RESULT", // Kết quả thử thách
  CLASSIFICATION: "CLASSIFICATION", // Xếp loại
  COMMON_PARAMETER: "COMMON_PARAMETER", // Tham số dùng chung
  COOPERATE_COMMISSION: "COOPERATE_COMMISSION", // Tỉ lệ hoa hồng BDS3
  CREATION_DATA_TYPE: "CREATION_DATA_TYPE", // Nguồn sinh dữ liệu
  DEGREE_CATEGORY: "DEGREE_CATEGORY", // Bằng cấp
  DEPARTMENT_LEVEL: "DEPARTMENT_LEVEL", // Cấp của đơn vị
  DEPARTMENT_OTHER_FEATURE: "DEPARTMENT_OTHER_FEATURE", // Đặc tính khác của Khối/ Phòng ban
  DETECT_DIRECT_MNG: "DETECT_DIRECT_MNG", // Cách xác định CBQL trực tiếp quản lý
  DEVELOP_METHOD: "DEVELOP_METHOD", // Hình thức phát triển
  DISPLAY_FIELD: "DISPLAY_FIELD", // Trường dữ liệu chèn vào nội dung mẫu email
  DOCUMENT_CATEGORY: "DOCUMENT_CATEGORY", // Các loại tài liệu/ văn bản của MBS
  DUTY_EXE_METHOD: "DUTY_EXE_METHOD", // Hình thức thực hiện nghĩa vụ
  EMAIL_TYPE: "EMAIL_TYPE", // Loại email
  EMPLOYEE_TYPE: "EMPLOYEE_TYPE", // Loại nhân viên
  FIRST_SERVICES: "FIRST_SERVICES", // Dịch vụ lần đầu của TK chứng khoán
  FIXED_FACTOR: "FIXED_FACTOR", // Tỉ lệ giới hạn cho TK đặc biệt (loại tỉ lệ cố định)
  FOREIGN_LANGUAGE: "FOREIGN_LANGUAGE", // Ngoại ngữ
  FOREIGN_LANGUAGE_DEGREE: "FOREIGN_LANGUAGE_DEGREE", // Trình độ ngoại ngữ
  FORM_OF_TRAINING: "FORM_OF_TRAINING", // Hình thức đào tạo
  GENDER: "GENDER", // Giới tính
  ID_ISSUED_PLACE: "ID_ISSUED_PLACE", // Nơi cấp CMT/CCCD
  LABOR_CONTRACT_TYPE: "LABOR_CONTRACT_TYPE", // Loại hợp đồng
  LACK_CATEGORY: "LACK_CATEGORY", // Danh mục thiếu phiếu lệnh
  LEAVE_OFF_REASON: "LEAVE_OFF_REASON", // Lý do nghỉ việc
  LEAVE_OFF_DUTY_CATEGORY: "LEAVE_OFF_DUTY_CATEGORY", // Loại các khoản nghĩa vụ khi nghỉ việc
  LEAVE_OFF_REQUIREMENT_FILE: "LEAVE_OFF_REQUIREMENT_FILE", // Các hồ sơ yêu cầu khi nghỉ việc
  LEAVE_OFF_RIGHT_CATEGORY: "LEAVE_OFF_RIGHT_CATEGORY", // Loại các khoản quyền lợi khi nghỉ việc
  LEAVE_REASON: "LEAVE_REASON", // Lý do nghỉ
  LIMIT_FACTOR: "LIMIT_FACTOR", // Tỉ lệ giới hạn cho TK đặc biệt (loại tỉ lệ tối đa)
  LIMIT_FACTOR_TYPE: "LIMIT_FACTOR_TYPE", // Loại mức tỉ lệ tối đa trong tài khoản đặc biệt
  LIST_TYPE: "LIST_TYPE", // Loại danh mục cây phân cấp
  LOG_FUNCTION: "LOG_FUNCTION", // Các chức năng ghi log
  MANAGEMENT_LEVEL: "MANAGEMENT_LEVEL", // Level của CBNV
  MARITAL_STATUS: "MARITAL_STATUS", // Tình trạng hôn nhân
  MATRIX_TYPE: "MATRIX_TYPE", // Loại ma trận
  OPEN_ACCOUNT_CHANNEL: "OPEN_ACCOUNT_CHANNEL", // Kênh mở TK chứng khoán
  OTHER_PROFILE: "OTHER_PROFILE", // Hồ sơ khác của nhân sự
  PAYMENT_POSITION: "PAYMENT_POSITION", // Chức danh cho ma trận chi trả
  PENSION_FUND_CHANGE_TYPE: "PENSION_FUND_CHANGE_TYPE", // Loại thay đổi trong quỹ hưu trí
  PENSION_FUND_OPTIONS: "PENSION_FUND_OPTIONS", // Các phương án tham gia quỹ hưu trí
  PENSION_FUND_RATE: "PENSION_FUND_RATE", // Tỉ lệ chuyển quyền
  PENSION_FUND_STATUS: "PENSION_FUND_STATUS", // Trạng thái tham gia quỹ hưu trí
  PENSION_FUND_TYPE: "PENSION_FUND_TYPE", // Loại quỹ hưu trí
  POLICY_TURNOVER: "POLICY_TURNOVER", // Chế độ hưởng LKD
  POSITION: "POSITION", // Chức vụ
  POSITION_GROUP: "POSITION_GROUP", // Nhóm chức danh
  PROFILE_CATEGORY: "PROFILE_CATEGORY", // Loại hồ sơ
  PROFILE_TYPE: "PROFILE_TYPE", // Loại hồ sơ yêu cầu theo chức danh
  PROMULGATE_LEVEL: "PROMULGATE_LEVEL", // Cấp ban hành
  PROVICE: "PROVICE", // Tỉnh/thành
  RELATIVE: "RELATIVE", // Nhân thân
  RELATIVE_GENERAL_STATUS: "RELATIVE_GENERAL_STATUS", // Trạng thái tổng hợp của nhân thân
  SALARY_GROUP_TYPE: "SALARY_GROUP_TYPE", // Các nhóm lương
  SALARY_LEVEL: "SALARY_LEVEL", // Bậc lương
  SALARY_PROCESS_TYPE: "SALARY_PROCESS_TYPE", // Loại quá trình lương
  SAL_DATA_TYPE: "SAL_DATA_TYPE", // Loại dữ liệu lương (thực chi/dự chi)
  SAL_SALARY_PAST: "SAL_SALARY_PAST", // Nguồn sinh dữ liệu chế độ lương
  SEND_MAIL_POLICY_TURNOVER: "SEND_MAIL_POLICY_TURNOVER", // Chế độ hưởng LKD được gửi mail
  SPECIALIZED: "SPECIALIZED", // Chuyên ngành
  STATUS: "STATUS", // Trạng thái hoạt động
  STORE_STATUS: "STORE_STATUS", // Trạng thái lưu hồ sơ
  SUB_ACCOUNT: "SUB_ACCOUNT", // Các tiểu khoản TK chứng khoán
  TK1: "TK1", // Dịch vụ sản phẩm
  TRANING_ORGANIZATION: "TRANING_ORGANIZATION", // Các đơn vị đào tạo
  TYPE_CLOSED_LKD: "TYPE_CLOSED_LKD", // Loại khóa sổ
  WORKING_ADDRESS: "WORKING_ADDRESS", // Địa chỉ nơi làm việc
  WORKING_AREA: "WORKING_AREA", // Khu vực làm việc
  WORKING_PROCESS_TYPE: "WORKING_PROCESS_TYPE", // Loại biến động nhân sự
  WORKING_STATUS: "WORKING_STATUS", // Trạng thái làm việc
  WORKING_STATUS_02: "WORKING_STATUS_02", // Trạng thái làm việc 02
  WORKING_STATUS_03: "WORKING_STATUS_03", // Trạng thái làm việc 03
  WP_BEFORE_JOINED_MBS_TYPE: "WP_BEFORE_JOINED_MBS_TYPE", // Loại quá trình công tác (trước MBS/ Cũ tại MBS)
  ZONE: "ZONE", // Khu vực
  SPECIALIZED_FIELD: "SPECIALIZED_FIELD", // chứng chỉ chuyên môn
};

export const INTERNAL_DOCUMENT_CATEGORY = {
  POSITION_APPROVE: "POSITION_APPROVE", // Chức vụ duyệt
  DEPT_LEVEL_1: "DEPT_LEVEL_1",
  DOCUMENT_CATEGORY_INTERNAL: "DOCUMENT_CATEGORY_INTERNAL", // Loại văn bản nội bộ
  DOCUMENT_STATUS: "DOCUMENT_STATUS", // Trạng thái văn bản
  LIST_EMPLOYEE: "LIST_EMPLOYEE", // Người được ủy quyền
  FIELD_LEVEL_1: "FIELD_LEVEL_1", // Loại ủy quyền
  VALID_STATUS: "VALID_STATUS", // Trạng thái hiệu lực
  DELEGATED_AUTHORIZER: "DELEGATED_AUTHORIZER", // Người ủy quyền
  DOCUMENT_CATEGORY_DELEGATED: "DOCUMENT_CATEGORY_DELEGATED", // Loại văn bản phân cấp ủy quyền
};

export const CATEGORY_CODE = {
  RECRUITMENT_DEPARTMENT_EMPLOYEE: "RECRUITMENT_DEPARTMENT_EMPLOYEE",
  RECRUITMENT_DEPARTMENT_POSITION: "RECRUITMENT_DEPARTMENT_POSITION",
  RECRUITMENT_DEPARTMENT_LEVEL_2: "RECRUITMENT_DEPARTMENT_LEVEL_2",
  RECRUITMENT_DEPARTMENT_LEVEL_3: "RECRUITMENT_DEPARTMENT_LEVEL_3",
  RECRUITMENT_LIST_MANAGERS: "RECRUITMENT_LIST_MANAGERS",
  EVALUATION_MANAGER_BY_LEVEL: "EVALUATION_MANAGER_BY_LEVEL",
  ERP_HR_EMPLOYEE: "ERP_HR_EMPLOYEE",
  RECRUITMENT_RELATED_PERSONS: "RECRUITMENT_RELATED_PERSONS",
} as const;

export const CATEGORY_RECRUITMENT_CODE = {
  ERP_RECRUITMENT_POSITION_LEVEL: "ERP_RECRUITMENT_POSITION_LEVEL",
  ERP_EXPERIENCE_RECRUITMENT: "ERP_EXPERIENCE_RECRUITMENT",
  ERP_RECRUITMENT_REASON: "ERP_RECRUITMENT_REASON",
  ERP_RECRUITMENT_APPROVE_STATUS: "ERP_RECRUITMENT_APPROVE_STATUS",
  ERP_DEGREE_CATEGORY: "ERP_DEGREE_CATEGORY",
  ERP_SPECIALIZED: "ERP_SPECIALIZED",
  ERP_CERTIFICATE_TYPE: "ERP_CERTIFICATE_TYPE",
  ERP_FOREIGN_LANGUAGE: "ERP_FOREIGN_LANGUAGE",
  ERP_GENDER_2: "ERP_GENDER_2",
  ERP_WORKING_ADDRESS: "ERP_WORKING_ADDRESS",
} as const;

export const CATEGORY = {
  ...PERSONAL_INFORMATION_CATEGORY,
  ...INTERNAL_DOCUMENT_CATEGORY,
  ...CATEGORY_CODE,
  ...CATEGORY_RECRUITMENT_CODE,
};

export const CATEGORY_FACTORY = {
  [CATEGORY_CODE.RECRUITMENT_DEPARTMENT_EMPLOYEE]: () => ({
    url: getRecruitmentDepartmentEmployee(),
  }),
  [CATEGORY_CODE.RECRUITMENT_DEPARTMENT_POSITION]: () => ({
    url: getRecruitmentDepartmentPosition(),
  }),
  [CATEGORY_CODE.RECRUITMENT_DEPARTMENT_LEVEL_2]: () => ({
    url: getRecruitmentDepartmentEmployee(),
  }),
  [CATEGORY_CODE.RECRUITMENT_DEPARTMENT_LEVEL_3]: () => ({
    url: getRecruitmentDepartmentEmployee(),
  }),
  [CATEGORY_CODE.RECRUITMENT_LIST_MANAGERS]: (query) => ({
    url: getListManagersRecruitmentUrl(query?.id),
  }),
  [CATEGORY_CODE.EVALUATION_MANAGER_BY_LEVEL]: (query) => ({
    url: getManagerByLevelUrl(query?.screenCode),
  }),
  [CATEGORY_CODE.RECRUITMENT_RELATED_PERSONS]: () => ({
    url: getRelatedPersons(),
  }),
};

interface DataState {
  [code: string]: CategoryItem[];
}

interface InitialState {
  data: DataState;
  status: ReduxStateType;
}

interface LocationPayload {
  key: string;
  data: CategoryItem[];
}

const initialState: InitialState = {
  data: {},
  status: ReduxStateType.INIT,
};

const getCategorySlice = createSlice({
  name: "getCategory",
  initialState,
  reducers: {
    getCategoryStart: (
      state,
      action: PayloadAction<
        | string
        | {
            type: string;
            callback?: Function;
            query?: Record<string, any>;
            isUpdateNow?: boolean;
            params?: Record<string, any>;
          }
      >
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getCategorySuccess: (state, action: PayloadAction<LocationPayload>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = {
        ...state.data,
        [action.payload.key]: action.payload.data,
      };
    },
    getCategoryFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },

    resetCategory: () => {
      return { ...initialState };
    },

    resetCategoryByKey: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      const newData = { ...state.data };
      delete newData[key];
      state.data = newData;
    },
  },
});

export const {
  getCategoryStart,
  getCategorySuccess,
  getCategoryFailed,
  resetCategory,
  resetCategoryByKey,
} = getCategorySlice.actions;

export default getCategorySlice.reducer;
